import { iframeOrigin } from '../../lib/previewLaunchUrl';

/** The game's domain as partners see it in their ad accounts' domain lists. */
export function iframeHost(): string {
  const origin = iframeOrigin();
  if (!origin) return 'the game iframe domain';
  try {
    return new URL(origin).host;
  } catch {
    return origin;
  }
}
